import React, {useState, useRef, useEffect} from 'react';
import {ContentHeader} from '@components';
import {Button} from 'react-bootstrap';
import GoogleMapReact from 'google-map-react';
import ClockLoader from 'react-spinners/ClockLoader';
import {useStateWithCallbackLazy} from 'use-state-with-callback';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Column from './Column';
import {PfButton} from '@profabric/react-components';
import Select from 'react-select';
import {Form} from 'react-bootstrap';
import {DateTimePicker, DatePicker} from 'react-tempusdominus-bootstrap';
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';
import * as AuthService from '../../services/auth';
import {PfImage} from '@profabric/react-components';
import styled from 'styled-components';
import {logoutUser} from '@store/reducers/auth';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import {SelectedBox, SearchBox, Marker} from './MapElement';
import Modal from 'react-bootstrap/Modal';
import ModalPin from './modal/ModalPin';
import {toast} from 'react-toastify';
import {useSelector} from 'react-redux';
import Switch from 'react-bootstrap-switch';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import {AnyARecord} from 'dns';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { fas } from '@fortawesome/free-solid-svg-icons'

export default function MakeTrip(props: any) {
  const user = useSelector((state: any) => state.auth.currentUser);
  const [show, setShow] = useState(false);
  const [disable, setDisable] = useState(true);
  const [showOption, setShowOption] = useState(false);
  const [consent, setConsent] = useState({
    consent_url: '',
    consent_height: '0px',
    consent_submit: 'ยืนยัน',
    consent_id: '0',
    consent_size: 'lg'
  });
  const [icon, setIcon] = useState('fas fa-lock');
  const [islock, setIslock] = useState(true);
  // const [costCenter, setCostCenter] = useState('');
  const [key, setKey] = useState('plan');
  const [ibcApv, setIbcApv] = useState(true);
  // const [isPartnerMode, setPartnerMode] = useState(false);
  const [pin, setPin] = useState('');
  const [min, setMin] = useState(addDays(-1));
  const [max, setMax] = useState(addDays(30));
  const [plan, setPlan] = useState({
    typeid: {value: '', label: ''},
    siteid: {value: '', label: 'Loading...'},
    days: 1,
    vehicleid: [{value: '', label: 'เลือกยานพาหนะ'}],
    companyid: {value: '', label: ''},
    costid: {value: '', label: 'cost center'},
    apvPlanid: {value: '', label: 'เลือกผู้อนุมัติแผน', image: ''},
    apvActualid: {value: '', label: 'เลือกผู้อนุมัติผล', image: ''},
    apvPlanIbcid: {value: '', label: 'เลือก IBC', image: ''},
    objective: '',
    date_start: new Date(),
    date_stop: new Date(),
    totalExpend: 0,
    totaCost: 0,
    distance: 0,
    budget: 0
  });
  const [isLoading, setLoading] = useState(false);
  const [places, setPlaces] = useState<any[]>([]);
  const [company, setCompany] = useState<any[]>([]);
  const [marker, setMarker] = useState<any[]>([]);
  const [companySelected, setCompanySelected] = useState<any[]>([]);
  const [showMarker, setShowMarker] = useState(true);
  const [dropdownCar, setDropdownCar] = useState<any>({DATA: []});
  const [dropdownCarPublic, setDropdownCarPublic] = useState<any>({DATA: []});
  const [dropdownCarRent, setDropdownCarRent] = useState<any>({DATA: []});
  const [dropdownType, setDropdownType] = useState<any[]>([]);
  const [carsAvailable, setCarsAvailable] = useState<any>([]);
  const [dropdownApvPlan, setDropdownApvPlan] = useState<any>({
    DATA: [
      {
        value: '0',
        label: 'เลือกหัวหน้างาน',
        image: '',
        selected: false
      }
    ]
  });
  const [dropdownApvActual, setDropdownApvActual] = useState<any>({
    DATA: [
      {
        value: '0',
        label: 'เลือก CR',
        image: '',
        selected: false
      }
    ]
  });
  const [dropdownApvIBC, setDropdownApvIBC] = useState<any>({
    DATA: [
      {
        value: '0',
        label: 'เลือก Costcenter',
        image: '',
        selected: false
      }
    ]
  });
  const [dropdownCompany, setDropdownCompany] = useState<any>({DATA: []});
  const [dropdownCostcenter, setDropdownCostcenter] = useState<any>({DATA: []});
  const [dropdownExpend, setDropdownExpend] = useStateWithCallbackLazy<any>({
    DATA: []
  });
  const [dropdownSite, setDropdownSite] = useStateWithCallbackLazy<any>({
    DATA: []
  });
  const [myposition, setMyposition] = useState<any>({
    center: {
      lat: 13.545550016333902,
      lng: 100.96180662698616
    },
    zoom: 17
  });
  const [error, setError] = useState('');

  useEffect(() => {
    downloadDropdownWs();
    downloadConsentWs();
    findLocation();
    console.log(localStorage.getItem('gatekeeper_token'));
  }, []);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const downloadConsentWs = async () => {
    try {
      const consent = await AuthService.downloadConsent();
      console.log(consent);
      setShowOption(!consent.result);
      setConsent(consent.consent);
    } catch (error: any) {}
  };

  const insertConsentWs = async () => {
    try {
      const _consent = await AuthService.insertConsent(consent.consent_id);
    } catch (error: any) {}
  };

  function getDistanceFromLatLonInKm(
    lat1: number,
    lng1: number,
    lat2: number,
    lng2: number
  ) {
    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1); // deg2rad below
    var dLon = deg2rad(lng2 - lng1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
  }

  function deg2rad(deg: number) {
    return deg * (Math.PI / 180);
  }

  const downloadDropdownWs = async () => {
    try {
      const dropdowns = await AuthService.downloadDropdownCar(
        `${user.ID_EMP}?type=N`
      );
      console.log(dropdowns);
      if (dropdowns.error) throw 'timeout';

      //COMP, BOSS
      if (Object.keys(dropdowns).length !== 0) {
        setDropdownApvPlan(dropdowns.APV_PLAN);
        console.log('plan pass');
        setDropdownApvActual(dropdowns.APV_ACTUAL);
        console.log('actual pass');
        setDropdownCostcenter(dropdowns.COSTCENTER);
        console.log('costcenter pass');
        setDropdownExpend(dropdowns.EXPEND, () => {});
        console.log('expend pass');
        setDropdownCompany(dropdowns.COMPANY);
        console.log('company pass');
        setDropdownSite(dropdowns.SITE, () => {});
        console.log('site pass');

        setDropdownCar(dropdowns.CAR_MY);
        console.log('car pass');
        setDropdownCarPublic(dropdowns.CAR_PUBLIC);
        console.log('public pass');
        setDropdownCarRent(dropdowns.CAR_RENT);
        console.log('rent pass');

        setDropdownType(dropdowns.TYPE.DATA);
        console.log('type pass');

        if (dropdowns.APV_ACTUAL.ALLOW_SELECT === false) {
          setPlan((prevState) => ({
            ...prevState,
            apvActualid: dropdowns.APV_ACTUAL.DATA[0]
          }));
        }

        if (dropdowns.APV_PLAN.ALLOW_SELECT === false) {
          setPlan((prevState) => ({
            ...prevState,
            apvPlanid: dropdowns.APV_PLAN.DATA[0]
          }));
        }

        if (dropdowns.APV_PLAN.DATA.length === 1) {
          setPlan((prevState) => ({
            ...prevState,
            apvPlanid: dropdowns.APV_PLAN.DATA[0]
          }));
        }
      }
    } catch (error: any) {
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };

  const unlock = async () => {
    setShow(true);
  };

  const onChange = (value: string) => {
    setPin(value);
  };

  const handleClose = async () => {
    try {
      if (pin === '' || pin.length !== 4) throw 'timeout';
      const _date = await AuthService.verifyPinWs(pin);
      if (_date.error) throw 'timeout';
      setPlan((prevState) => ({
        ...prevState,
        date_start: new Date(_date.pin_date),
        date_stop: new Date(_date.pin_date)
      }));
      setMin(new Date(_date.pin_date));
      setMax(new Date(_date.pin_date));
      setShow(false);
      setIslock(false);
      setIcon('fas fa-unlock');
      toast.success('ทำการปลดล็อกแล้ว');
    } catch (error: any) {
      toast.error('pin ไม่ถูกกรอกหรือไม่ถูกต้อง');
      setShow(false);
    }
  };

  const handleCloseOption = async () => {
    setShowOption(false);
  };

  const handleConsentOption = async () => {
    setShowOption(false);
    insertConsentWs();
  };

  const handleGoOld = async () => {
    window.location.href =
      'http://cdsexp.doubleapaper.com/login.aspx?user_id=' + user.ID_EMP;
  };

  const downloadCarsAvailable = async (
    siteid: any,
    typeid: any,
    date_start: any,
    date_stop: any
  ) => {
    try {
      const offset = date_start.getTimezoneOffset();
      const thDate = new Date(date_start.getTime() - offset * 60 * 1000);

      const offset2 = date_stop.getTimezoneOffset();
      const thDate2 = new Date(date_stop.getTime() - offset2 * 60 * 1000);
      if (typeid === '3' || typeid === '4' || typeid === '5') {
        console.log(date_start);
        const carsAvailable = await AuthService.downloadCarsAvailable({
          typeid,
          date_start,
          date_stop,
          // date_start: thDate.toISOString().split('T')[0] + 'T00:00:00',
          // date_stop: thDate2.toISOString().split('T')[0] + 'T23:59:59',
          siteid
        });
        console.log(carsAvailable);
        setCarsAvailable(carsAvailable.availableCars);
      }
    } catch (error: any) {}
  };

  const downloadIbc = async (value: any) => {
    try {
      const ibc = await AuthService.downloadIbc(value);
      setDropdownApvIBC(ibc.APV_IBC);

      setPlan((prevState) => ({
        ...prevState,
        apvPlanIbcid: ibc.APV_IBC.DATA[0]
      }));
    } catch (error: any) {}
  };

  const checkIbcApvBudget = async (value: any, date_start: any) => {
    try {
      const offset = date_start.getTimezoneOffset();
      const thDate = new Date(date_start.getTime() - offset * 60 * 1000);
      const ibcApv = await AuthService.downloadIbcApv(
        value,
        thDate.toISOString().split('T')[0]
      );

      //จะอนุญาตเมื่อเดือนที่แล้วอนุมัติแล้ว และ 6 เดือนย้อนหลังอนุมัติหมดแล้ว
      //หรือเดือนที่แล้วยังไม่อนุมัติ และ 6 เดือนย้อนหลังอนุมัติหมดแล้ว และเป็นวันที่ 1-5 ของเดือนที่เดินทาง
      let allow = true;
      const y = date_start.getFullYear(),
        m = date_start.getMonth();
      const day1 = new Date(y, m, 1);
      const day5 = new Date(y, m, 6);

      if (ibcApv.apv_status == 'reject') {
        allow = false;
      } else if (date_start >= day1 && date_start <= day5) {
        allow = ibcApv.status_six_ago;
      } else {
        allow = ibcApv.status && ibcApv.status_six_ago;
      }

      setIbcApv(allow);
    } catch (error: any) {}
  };

  const downloadBudget = async (
    value: any,
    date: any,
    cost: any,
    _days: any
  ) => {
    try {
      //plan.date_start
      console.log(value);
      console.log(date);
      const offset = date.getTimezoneOffset();
      console.log(offset);
      const thDate = new Date(date.getTime() - offset * 60 * 1000);
      console.log(thDate.toISOString().split('T')[0]);

      const budget = await AuthService.downloadBudget(
        value,
        thDate.toISOString().split('T')[0]
      );
      if (budget.length === 1) {
        setPlan((prevState) => ({
          ...prevState,
          budget: budget[0].Budget_Left
        }));

        if (
          Number(budget[0].Budget_Left) - Number(cost) * _days.toFixed(0) <=
          0
        ) {
          //ไม่ให้จอง
          setError(
            `งบไม่เพียงพอ ตรวจรายการเบิกที่เมนู "ค่าใช้จ่ายกลุ่มต้นทุน" และติดต่อ CR(5-5231) หรือ <a href='https://youtu.be/i4rP4FZrfuo' target='_blank'>รับชมวิดีโอสาธิตการโยกงบ</a> เพื่อเพิ่ม/โยกงบ [${_days.toFixed(
              0
            )}วัน : ${
              plan.vehicleid.length === 1 &&
              (plan.vehicleid[0].value === 'CS_22' ||
                plan.vehicleid[0].value === 'CS_922')
                ? (1800 * _days.toFixed(0)).toFixed(2)
                : (Number(cost) * _days.toFixed(0)).toFixed(2)
            }บาท]`
          );
          setDisable(true);
        } else {
          setError('');
          setDisable(false);
        }
      } else {
        setPlan((prevState) => ({
          ...prevState,
          budget: 0
        }));
        //ไม่ให้จอง
        setError('งบไม่เพียงพอ กรุณาติดต่อ CR(5-5231) เพื่อเพิ่ม/โยกงบ');
        setDisable(true);
      }
    } catch (error: any) {}
  };

  function addDays(days: number) {
    var result = new Date();
    result.setDate(result.getDate() + days);
    return result;
  }

  const mapRef = useRef();
  const modeRef = useRef(false);
  const mapApi = useRef();
  const mapDirection = useRef();
  const apiReady = useRef(false);
  const companyRef = useRef<any>([]);

  const StyledUserImage = styled(PfImage)``;

  const findLocation = () => {
    console.log('position');
    navigator.geolocation.getCurrentPosition(
      (position) => {
        // setMyposition((prevState) => ({
        //   ...prevState,
        //   center: {
        //     lat: position.coords.latitude,
        //     lng: position.coords.longitude
        //   }
        // }));

        setMyposition({
          center: {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          },
          zoom: 17
        });

        //DAP 13.544646052243355,100.96189110190038
        //IP1 13.925782497047074,101.58327105353642
        //IP2 13.715847342171976, 101.46337351583271
        const d_dap = getDistanceFromLatLonInKm(
          position.coords.latitude,
          position.coords.longitude,
          13.544646052243355,
          100.96189110190038
        );
        const d_ip1 = getDistanceFromLatLonInKm(
          position.coords.latitude,
          position.coords.longitude,
          13.925782497047074,
          101.58327105353642
        );
        const d_ip2 = getDistanceFromLatLonInKm(
          position.coords.latitude,
          position.coords.longitude,
          13.715847342171976,
          101.46337351583271
        );

        console.log(d_dap);
        console.log(d_ip1);
        console.log(d_ip2);

        let array = [d_ip1, d_ip2, d_dap];
        let minimum = Math.min(...array);
        let minIndex = array.indexOf(minimum);

        if (minIndex === 0) {
          setPlan((prevState) => ({
            ...prevState,
            siteid: {value: '1', label: 'IP1'}
          }));
        }
        if (minIndex === 1) {
          setPlan((prevState) => ({
            ...prevState,
            siteid: {value: '2', label: 'IP2'}
          }));
        }
        if (minIndex === 2) {
          setPlan((prevState) => ({
            ...prevState,
            siteid: {value: '4', label: 'DAP'}
          }));
        }
      },
      (err) => {
        console.log(err);
        setPlan((prevState) => ({
          ...prevState,
          siteid: {value: '1', label: 'IP1'}
        }));
      }
    );
  };

  const handleApiLoaded = (map: any, maps: any) => {
    if (map && maps) {
      mapRef.current = map;
      mapApi.current = maps;
      apiReady.current = true;
      var mapOptions = {
        mapId: 'DEMO_MAP_ID',
        gestureHandling: 'greedy',
        zoom: 17,
        styles: [
          {
            featureType: 'all',
            elementType: 'all',
            stylers: [
              {
                visibility: 'on'
              }
            ]
          }
        ],
        mapTypeControl: true,
        mapTypeId: maps.MapTypeId.ROADMAP,
        mapTypeControlOptions: {
          style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: maps.ControlPosition.BOTTOM_CENTER,
          mapTypeIds: [maps.MapTypeId.ROADMAP, maps.MapTypeId.SATELLITE]
        }
      };
      map.addListener('click', async (e: any) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();
        console.log(lat, lng);
        const place = {lat: lat, lng: lng};
        const placeName = await getName(place);
        console.log('HERE2');
        console.log(mapRef.current);

        //ต้องเช็คและโชว์ company แระ
        let _company = !modeRef.current ? [] : await getCompany(place);
        addPlace({...place, name: placeName}, _company);
        setTimeout(function () {
          setMyposition({
            center: {
              lat: lat,
              lng: lng
            },
            zoom: 17
          });

          map.setZoom(17);
        }, 2000);
      });

      map.setOptions(mapOptions);
      const directionsRenderer = new google.maps.DirectionsRenderer({
        draggable: true
      });
      directionsRenderer.addListener('directions_changed', () => {
        try {
          const directions = directionsRenderer.getDirections();
          if (directions) {
            let total = 0;
            const myroute = directions.routes[0];

            if (!myroute) {
              return;
            }

            for (let i = 0; i < myroute.legs.length; i++) {
              total += myroute.legs[i].distance.value;
            }

            setPlan((prevState) => {
              downloadBudget(
                prevState.costid.value,
                prevState.date_start,
                prevState.vehicleid.length === 1 &&
                  (prevState.vehicleid[0].value === 'CS_22' ||
                    prevState.vehicleid[0].value === 'CS_922')
                  ? 1800
                  : (total / 1000) * 5.5,
                prevState.days
              );
              return {
                ...prevState,
                distance: total,
                totaCost:
                  prevState.vehicleid.length === 1 &&
                  (prevState.vehicleid[0].value === 'CS_22' ||
                    prevState.vehicleid[0].value === 'CS_922')
                    ? 1800
                    : (total / 1000) * 5.5
              };
            });
          }
        } catch {
          alert('เลือกเส้นทางนั้นไม่ได้');
        }
      });

      directionsRenderer.setMap(map);
      mapDirection.current = directionsRenderer;
      setPlaces([]);
      setMarker([]);
    }
  };

  const getName = (place: any) => {
    const geocoder = new google.maps.Geocoder();
    const result = geocoder
      .geocode({location: place})
      .then((response) => {
        if (response.results[0]) {
          return response.results[0].formatted_address;
        } else {
          return 'n/a';
        }
      })
      .catch((e) => {
        return 'n/a';
      });
    return result;
  };

  const getCompany = async (place: any) => {
    try {
      setLoading(true);
      const _company = await AuthService.downloadcompany(place);
      setLoading(false);
      return _company;
    } catch {
      return [];
    }
  };

  const setRoute = (places: any) => {
    if (places.length > 1) {
      const directionsService = new google.maps.DirectionsService();
      mapDirection.current.setMap(mapRef.current);

      const waypoints = places.map((p) => ({
        location: {lat: p.lat, lng: p.lng},
        stopover: true
      }));
      const origin = waypoints.shift().location;
      const destination = waypoints.pop().location;

      directionsService.route(
        {
          origin: origin,
          destination: destination,
          waypoints: waypoints,

          optimizeWaypoints: false,
          avoidHighways: true,
          avoidTolls: true,
          provideRouteAlternatives: false,
          travelMode: google.maps.TravelMode.DRIVING
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            console.log(result);
            mapDirection.current.setDirections(result);

            var totalDistance = 0;
            var legs = result.routes[0].legs;
            for (var i = 0; i < legs.length; ++i) {
              totalDistance += legs[i].distance.value;
            }
            setPlan((prevState) => ({
              ...prevState,
              distance: totalDistance,
              // totaCost: (totalDistance / 1000) * 5.5
              totaCost:
                prevState.vehicleid.length === 1 &&
                (prevState.vehicleid[0].value === 'CS_22' ||
                  prevState.vehicleid[0].value === 'CS_922')
                  ? 1800
                  : (totalDistance / 1000) * 5.5
            }));
          } else {
            console.error(`error fetching directions ${result}`);
          }
        }
      );
    } else {
      if (mapDirection.current) {
        mapDirection.current.setMap(null);
      }
    }
  };

  const addByMap = async (id) => {
    const _item = companyRef.current.find(
      (e) => id.toString() === e.value.toString()
    );
    console.log(_item);

    // console.log(companyRef.current);

    // if ((companyRef.current.find((e)=>(id.toString() === e.value.toString())))===undefined){
    setCompanySelected((prevState) => {
      // companyRef.current = [...prevState, _item];
      return [...prevState, _item];
    });
    // }
    console.log(id);
  };

  const addPlace = (place: any, _company: any) => {
    console.log(_company);
    setPlaces((prevState) => {
      setRoute([...prevState, place]);
      // if ([...prevState, place].length > 1) setShowMarker(false);

      let _temp = _company.map((e, i) => ({
        lat: Number(e.Lat),
        lng: Number(e.Long),
        name: `${i + 1}. ${e.label} [${e.value}]`,
        color: '#008000',
        title: `${i + 1}`,
        url: e.ImageUrl
          ? e.ImageUrl
          : 'https://api-passport.advanceagro.net/img/no_image_available.jpg',
        scale: 1.5 - 0.05 * i
      }));

      setCompany(_company.map((e, i) => ({...e, index: i})));
      companyRef.current = _company.map((e, i) => ({...e, index: i}));

      if ([...prevState, place].length > 1) {
        setMarker((prevState) => {
          return [..._temp];
        });
      } else {
        setMarker((prevState) => {
          return [place, ..._temp];
        });
      }
      return [...prevState, place];
    });
  };

  const ResetMap = () => {
    setCompanySelected([]);
    setCompany([]);
    companyRef.current = [];
    setPlaces([]);
    setRoute([]);
    setShowMarker(true);
    setPlan((prevState) => ({
      ...prevState,
      distance: 0,
      totaCost: 0
    }));
    setMarker([]);
  };

  const onDragEnd = ({source, destination, draggableId}) => {
    //TODO
    if (!destination) {
      return;
    }
    const items = reOrder(places, source.index, destination.index);
    console.log(source.index + '' + destination.index);
    setPlaces(items);
    setRoute(items);
  };

  const reOrder = (places, startIndex, endIndex) => {
    const result = Array.from(places);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onDelete = (index) => {
    const result = Array.from(places);
    result.splice(index, 1);
    console.log(result.length);
    if (result.length === 1) {
      setShowMarker(true);
      setMarker(result);
      setPlan((prevState) => ({
        ...prevState,
        distance: 0,
        totaCost: 0
      }));
    }
    if (result.length === 0) {
      setShowMarker(true);
      setMarker([]);
    }

    setPlaces(result);
    setRoute(result);
  };

  const handleSubmit = async () => {
    console.log(plan);
    if (handleValidation()) {
      setLoading(true);
      setDisable(true);
      try {
        const input = {
          plan: plan,
          places: places,
          expend: dropdownExpend,
          partners: companySelected
        };
        const result = await AuthService.addPlan(input);
        if (result.error) throw result.error;
        setLoading(false);
        toast.success('วางแผนสำเร็จแล้ว');
        navigate('/trip-me');
      } catch (error: any) {
        toast.error(error);
        setLoading(false);
      }
    }
  };

  const handleValidation = () => {
    let errors = '';
    let formIsValid = true;

    if (plan.apvActualid.value === '') {
      formIsValid = false;
      errors = errors + 'ผู้อนุมัติผล, ';
    }
    if (plan.apvPlanid.value === '') {
      formIsValid = false;
      errors = errors + 'ผู้อนุมัติแผน, ';
    }
    if (plan.apvPlanIbcid.value === '') {
      formIsValid = false;
      errors = errors + 'ไม่พบ IBC กรุณาติดต่อ CR(5-5231) เพื่อเพิ่ม IBC, ';
    }
    if (plan.companyid.value === '') {
      formIsValid = false;
      errors = errors + 'บริษัท, ';
    }
    if (plan.costid.value === '') {
      formIsValid = false;
      errors = errors + 'costcenter, ';
    }
    // if (plan.distance === 0) {
    //   formIsValid = false;
    //   errors = errors + 'map, ';
    // }
    if (places.length <= 1) {
      formIsValid = false;
      errors = errors + 'map, ';
    }
    if (plan.objective === '') {
      formIsValid = false;
      errors = errors + 'วัตถุประสงค์, ';
    }
    if (plan.typeid.value === '') {
      formIsValid = false;
      errors = errors + 'ประเภทการเดินทาง, ';
    }
    if (plan.vehicleid.length === 0 || plan.vehicleid[0].value === '') {
      formIsValid = false;
      errors = errors + 'ยานพาหนะ, ';
    }
    if (plan.date_stop < plan.date_start) {
      formIsValid = false;
      errors = errors + 'วันเดินทางกลับน้อยกว่าไป, ';
    }

    if (!formIsValid) setError(`Required: ${errors}`);
    else setError('');
    return formIsValid;
  };

  const getListStyle = (isDraggingOver) => ({
    height: '400px',
    background: isDraggingOver ? 'lightblue' : 'white'
  });

  // const dropdownType = [
  //   {value: '1', label: 'เบิกค่าเดินทาง (cdsexp)'},
  //   {
  //     value: '2',
  //     label: 'รถบริการ (carservice)'
  //     // isDisabled: true
  //   },
  //   {
  //     value: '3',
  //     label: 'ยืมรถ (rent car)'
  //     // isDisabled: true
  //   },
  //   {
  //     value: '4',
  //     label: 'ยืมรถ-คนขับ (rent car-driver)'
  //     // isDisabled: true
  //   },
  //   {
  //     value: '5',
  //     label: 'ยืมรถ-รถบริษัท (company car)'
  //     // isDisabled: true
  //   }
  // ];

  const setNewSelected = (v) => {
    const _selected = v.reduce((prev, curr) => [...prev, curr.value], []);

    let temp = dropdownExpend.DATA.map((e) => {
      if (_selected.includes(e.value)) return {...e, selected: true};
      else return {...e, selected: false};
    });

    setDropdownExpend(
      (prevState) => ({...prevState, DATA: temp}),
      (selected) => {
        const sum = selected.DATA.filter(
          (e) => e.cal === true && e.selected === true
        ).reduce((prev, curr) => prev + curr.amount, 0);
        setPlan((prevState) => ({
          ...prevState,
          totalExpend: sum
        }));
      }
    );
  };

  const onValueChange = (index, value) => {
    let temp = dropdownExpend.DATA.map((e) => {
      if (e.value === index) return {...e, amount: parseInt(value)};
      else return e;
    });
    setDropdownExpend(
      (prevState) => ({...prevState, DATA: temp}),
      (selected) => {
        const sum = selected.DATA.filter(
          (e) => e.cal === true && e.selected === true
        ).reduce((prev, curr) => prev + curr.amount, 0);
        setPlan((prevState) => ({
          ...prevState,
          totalExpend: sum
        }));
      }
    );
  };

  // const numberOfdays = (_dstart: Date, _dstop: Date) => {
  //   const _r = _dstop.getTime() - _dstart.getTime();
  //   const _d = _r / (1000 * 3600 * 24);
  //   console.log("MOMO");
  //   console.log(_d);
  //   return _d + 1;
  // };

  const numberOfdays = (_dstart: Date, _dstop: Date) => {
    console.log('MOMO: ');
    var start_ref = new Date(2025, 0, 0);

    var diff_1 =
      _dstart -
      start_ref +
      (start_ref.getTimezoneOffset() - _dstart.getTimezoneOffset()) * 60 * 1000;
    var oneDay = 1000 * 60 * 60 * 24;
    var day_1 = Math.floor(diff_1 / oneDay);

    var diff_2 =
      _dstop -
      start_ref +
      (start_ref.getTimezoneOffset() - _dstop.getTimezoneOffset()) * 60 * 1000;
    var day_2 = Math.floor(diff_2 / oneDay);

    console.log('day_1: ' + day_1);
    console.log('day_2: ' + day_2);
    return day_2 - day_1 + 1;
  };

  const getMapOptions = (maps: any) => {
    return {
      mapId: 'DEMO_MAP_ID',
      streetViewControl: false,
      scaleControl: true,
      fullscreenControl: true,
      styles: [
        {
          featureType: 'all',
          elementType: 'all',
          stylers: [
            {
              visibility: 'on'
            }
          ]
        }
      ],
      gestureHandling: 'greedy',
      disableDoubleClickZoom: true,
      // minZoom: 11,
      // maxZoom: 18,

      mapTypeControl: true,
      // mapTypeId: maps.MapTypeId.ROADMAP,
      mapTypeControlOptions: {
        style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: maps.ControlPosition.BOTTOM_CENTER,
        mapTypeIds: [maps.MapTypeId.ROADMAP, maps.MapTypeId.SATELLITE]
      },

      zoomControl: true,
      clickableIcons: false
    };
  };

  return (
    <div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>ปลดล็อกเพื่อวางแผนย้อนหลัง</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              กรุณากรอกรหัส 4 หลักที่ได้จาก CR เพื่อปลดล็อกการวางแผนย้อนหลัง
            </div>
            <div
              className="col-12"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <ModalPin onChange={onChange}></ModalPin>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleClose}>
            ยืนยันรหัส
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showOption}
        onHide={handleCloseOption}
        size={Object.keys(consent).length != 0 ? consent.consent_size : 'lg'}
      >
        <Modal.Header closeButton>
          <Modal.Title>ประกาศ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container row m-0">
            <iframe
              src={Object.keys(consent).length != 0 ? consent.consent_url : ''}
              height={
                Object.keys(consent).length != 0
                  ? consent.consent_height
                  : '0px'
              }
              width={'100%'}
              frameBorder={0}
            />
            <div className="col-12 mt-3">
              <div style={{textAlign: 'center'}}>
                <Button onClick={handleConsentOption}>
                  {Object.keys(consent).length != 0
                    ? consent.consent_submit
                    : ''}
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ContentHeader title="Make a trip" />
      <section className="content">
        <div className="container-fluid">
          <div className="row" style={{paddingBottom: '60px'}}>
            <div className="col-12 col-md-9">
              <Card className="card-primary">
                <div className={isLoading ? 'overlay dark' : 'd-none'}>
                  <ClockLoader color="#c4c4c4" />
                </div>
                <div
                  className={
                    !apiReady.current && key === 'map'
                      ? 'overlay dark'
                      : 'd-none'
                  }
                >
                  <span style={{color: 'white', fontSize: 30}}>
                    LOADING MAP...
                  </span>
                </div>
                <Card.Body>
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className="mb-3"
                  >
                    <Tab eventKey="plan" title="กรอกข้อมูล">
                      <div className="row">
                        <Form.Group className="mb-3 col-md-1">
                          <Form.Label>#</Form.Label>
                          <Button
                            className="col-12"
                            onClick={unlock}
                            variant={islock ? 'secondary' : 'success'}
                          >
                            {/* <FontAwesomeIcon icon={fas.faMapMarkerAlt} /> */}
                            <i className={icon} />
                          </Button>
                        </Form.Group>
                        {plan.typeid.value === '1' ||
                        plan.typeid.value === '1001' ? (
                          <Form.Group className="mb-3 col-md-5">
                            <Form.Label>วันเวลาที่เดินทางไป</Form.Label>
                            <DatePicker
                              minDate={min}
                              maxDate={max}
                              date={plan.date_start}
                              format="YYYY-MM-DD"
                              onChange={(e: any) => {
                                setPlan((prevState) => {
                                  console.log(prevState);
                                  downloadBudget(
                                    prevState.costid.value,
                                    e.date.toDate(),
                                    prevState.totaCost,
                                    prevState.days
                                  );

                                  checkIbcApvBudget(
                                    prevState.costid.value,
                                    e.date.toDate()
                                  );

                                  return {
                                    ...prevState,
                                    date_start: e.date.toDate(),
                                    date_stop: e.date.add(2, 'hours').toDate()
                                  };
                                });
                              }}
                            />
                          </Form.Group>
                        ) : (
                          <Form.Group className="mb-3 col-md-5">
                            <Form.Label>วันเวลาที่เดินทางไป</Form.Label>
                            <DateTimePicker
                              minDate={min}
                              maxDate={max}
                              date={plan.date_start}
                              format="YYYY-MM-DD HH:mm"
                              onChange={async (e: any) => {
                                setPlan((prevState) => {
                                  downloadBudget(
                                    prevState.costid.value,
                                    e.date.toDate(),
                                    prevState.totaCost,
                                    numberOfdays(
                                      e.date.toDate(),
                                      e.date.clone().add(2, 'hours').toDate()
                                    )
                                  );

                                  downloadCarsAvailable(
                                    prevState.siteid.value,
                                    prevState.typeid.value,
                                    e.date.toDate(),
                                    e.date.clone().add(2, 'hours').toDate()
                                  );

                                  checkIbcApvBudget(
                                    prevState.costid.value,
                                    e.date.toDate()
                                  );

                                  return {
                                    ...prevState,
                                    date_start: e.date.toDate(),
                                    date_stop: e.date
                                      .clone()
                                      .add(2, 'hours')
                                      .toDate(),
                                    days: numberOfdays(
                                      e.date.toDate(),
                                      e.date.clone().add(2, 'hours').toDate()
                                    )
                                  };
                                });
                              }}
                            />
                          </Form.Group>
                        )}

                        {plan.typeid.value === '1' ||
                        plan.typeid.value === '1001' ? (
                          <div className="mb-3 col-md-6"></div>
                        ) : (
                          <Form.Group className={'mb-3 col-md-6'}>
                            <Form.Label>วันเวลาที่เดินทางกลับ</Form.Label>
                            <DateTimePicker
                              date={plan.date_stop}
                              format="YYYY-MM-DD HH:mm"
                              onChange={(e: any) => {
                                setPlan((prevState) => {
                                  downloadBudget(
                                    prevState.costid.value,
                                    prevState.date_start,
                                    prevState.totaCost,
                                    numberOfdays(
                                      prevState.date_start,
                                      e.date.toDate()
                                    )
                                  );

                                  downloadCarsAvailable(
                                    prevState.siteid.value,
                                    prevState.typeid.value,
                                    prevState.date_start,
                                    e.date.toDate()
                                  );

                                  return {
                                    ...prevState,
                                    date_stop: e.date.toDate(),
                                    days: numberOfdays(
                                      prevState.date_start,
                                      e.date.toDate()
                                    )
                                  };
                                });
                              }}
                            />
                          </Form.Group>
                        )}
                        <Form.Group className="mb-3 col-md-4">
                          <Form.Label>ประเภทการเดินทาง</Form.Label>
                          <Select
                            options={dropdownType}
                            onChange={(v: any) => {
                              setPlan((prevState) => {
                                downloadCarsAvailable(
                                  prevState.siteid.value,
                                  v.value,
                                  prevState.date_start,
                                  prevState.date_stop
                                );

                                return {
                                  ...prevState,
                                  typeid: v,
                                  vehicleid:
                                    v.value === '1'
                                      ? [{value: '', label: 'เลือกยานพาหนะ'}]
                                      : []
                                };
                              });
                            }}
                          />
                        </Form.Group>
                        {plan.typeid.value === '1' ||
                        plan.typeid.value === '1001' ? (
                          <div className="mb-3 col-md-3"></div>
                        ) : (
                          <Form.Group className={'mb-3 col-md-3'}>
                            <Form.Label>
                              {plan.typeid.value === '2'
                                ? 'คนขับสำนักงาน'
                                : 'ต้นทาง'}
                            </Form.Label>
                            <Select
                              value={plan.siteid}
                              options={dropdownSite.DATA}
                              onChange={(v: any) => {
                                setPlan((prevState) => {
                                  downloadCarsAvailable(
                                    v.value,
                                    prevState.typeid.value,
                                    prevState.date_start,
                                    prevState.date_stop
                                  );

                                  return {
                                    ...prevState,
                                    siteid: v
                                  };
                                });
                              }}
                            />
                          </Form.Group>
                        )}
                        <Form.Group className="mb-3 col-md-5">
                          <Form.Label>
                            เลือกรถ (รถบริการเลือกได้หลายคัน)
                          </Form.Label>
                          <Select
                            isMulti={plan.typeid.value === '2'}
                            value={plan.vehicleid}
                            options={
                              plan.typeid.value === '1' ||
                              plan.typeid.value === '1001'
                                ? dropdownCar.DATA
                                : plan.typeid.value === '2'
                                ? dropdownCarPublic.DATA
                                : dropdownCarRent.DATA.filter((e: any) =>
                                    carsAvailable.includes(e.value)
                                  )
                            }
                            onChange={(v: any) => {
                              setPlan((prevState) => {
                                console.log('HIHI5');
                                console.log(
                                  prevState.typeid.value === '2' &&
                                    v.length === 1 &&
                                    (v[0].value === 'CS_22' ||
                                      v[0].value === 'CS_922')
                                    ? 1800
                                    : (prevState.distance / 1000) * 5.5
                                );

                                downloadBudget(
                                  prevState.costid.value,
                                  prevState.date_start,
                                  prevState.typeid.value === '2' &&
                                    v.length === 1 &&
                                    (v[0].value === 'CS_22' ||
                                      v[0].value === 'CS_922')
                                    ? 1800
                                    : (prevState.distance / 1000) * 5.5,
                                  prevState.days

                                  // prevState.costid.value,
                                  // prevState.date_start,
                                  // prevState.vehicleid.length === 1 &&
                                  //   (prevState.vehicleid[0].value === 'CS_22' ||
                                  //     prevState.vehicleid[0].value === 'CS_922')
                                  //   ? 1800
                                  //   : (total / 1000) * 5.5,
                                  // prevState.days
                                );
                                return {
                                  ...prevState,
                                  totaCost:
                                    prevState.typeid.value === '2' &&
                                    v.length === 1 &&
                                    (v[0].value === 'CS_22' ||
                                      v[0].value === 'CS_922')
                                      ? 1800
                                      : (prevState.distance / 1000) * 5.5,
                                  vehicleid: plan.typeid.value === '2' ? v : [v]
                                };
                              });
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3 col-md-12">
                          <Form.Control
                            as="textarea"
                            // value={costCenter}
                            value={plan.objective}
                            placeholder={
                              plan.typeid.value === '2'
                                ? 'วัตถุประสงค์, หากมีค่า standby ให้เลือกค่าใช้จ่ายอื่นๆ เป็น "ค่า standby" และใส่จำนวนชั่วโมงตามจริง'
                                : 'วัตถุประสงค์'
                            }
                            onChange={(e) => {
                              setPlan((prevState) => ({
                                ...prevState,
                                objective: e.target.value
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3 col-md-6">
                          <Select
                            placeholder={'บริษัทรับทราบค่าใช้จ่าย'}
                            options={dropdownCompany.DATA}
                            onChange={(v: any) => {
                              setPlan((prevState) => ({
                                ...prevState,
                                companyid: v,
                                costid: {value: '', label: 'cost center'}
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3 col-md-6">
                          <Select
                            value={plan.costid}
                            placeholder={'cost center'}
                            options={
                              plan.companyid.value === ''
                                ? dropdownCostcenter.DATA
                                : dropdownCostcenter.DATA.filter(
                                    (e) => e.company === plan.companyid.value
                                  )
                            }
                            onChange={(v: any) => {
                              setPlan((prevState) => {
                                downloadBudget(
                                  v.value,
                                  prevState.date_start,
                                  prevState.totaCost,
                                  prevState.days
                                );

                                downloadIbc(v.value);

                                checkIbcApvBudget(
                                  v.value,
                                  prevState.date_start
                                );

                                return {
                                  ...prevState,
                                  costid: v
                                };
                              });
                              console.log(v);
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3 col-md-4">
                          <Form.Label>หัวหน้างาน</Form.Label>
                          <Select
                            isDisabled={!dropdownApvPlan.ALLOW_SELECT}
                            value={
                              !dropdownApvPlan.ALLOW_SELECT
                                ? dropdownApvPlan.DATA[0]
                                : plan.apvPlanid
                            }
                            placeholder={'เลือกผู้อนุมัติแผน'}
                            options={dropdownApvPlan.DATA}
                            formatOptionLabel={(e) => (
                              <div className="d-flex">
                                <StyledUserImage
                                  src={e.image}
                                  fallbackSrc="/img/default-profile.png"
                                  width={34}
                                  height={34}
                                  rounded
                                />
                                {/* <img src={`${e.image}&size=34`} className="rounded"/> */}
                                <span className="align-self-center ml-2">
                                  {e.label}
                                </span>
                              </div>
                            )}
                            onChange={(v: any) =>
                              setPlan((prevState) => ({
                                ...prevState,
                                apvPlanid: v
                              }))
                            }
                          />
                        </Form.Group>
                        <Form.Group className="mb-3 col-md-4">
                          <Form.Label>IBC</Form.Label>
                          <Select
                            isDisabled={!dropdownApvIBC.ALLOW_SELECT}
                            value={dropdownApvIBC.DATA[0]}
                            placeholder={'IBC'}
                            options={dropdownApvIBC.DATA}
                            formatOptionLabel={(e) => (
                              <div className="d-flex">
                                <StyledUserImage
                                  src={e.image}
                                  fallbackSrc="/img/default-profile.png"
                                  width={34}
                                  height={34}
                                  rounded
                                />
                                {/* <img src={`${e.image}&size=34`} className="rounded"/> */}
                                <span className="align-self-center ml-2">
                                  {e.label}
                                </span>
                              </div>
                            )}
                            onChange={(v: any) =>
                              setPlan((prevState) => ({
                                ...prevState,
                                apvPlanIbcid: v
                              }))
                            }
                          />
                        </Form.Group>
                        <Form.Group className="mb-3 col-md-4">
                          <Form.Label>CR</Form.Label>
                          <Select
                            isDisabled={!dropdownApvActual.ALLOW_SELECT}
                            value={
                              !dropdownApvActual.ALLOW_SELECT
                                ? dropdownApvActual.DATA[0]
                                : null
                            }
                            placeholder={'เลือกผู้อนุมัติผล'}
                            options={dropdownApvActual.DATA}
                            onChange={(v: any) =>
                              setPlan((prevState) => ({
                                ...prevState,
                                apvActualid: v
                              }))
                            }
                            formatOptionLabel={(e) => (
                              <div className="d-flex">
                                <StyledUserImage
                                  src={e.image}
                                  fallbackSrc="/img/default-profile.png"
                                  width={34}
                                  height={34}
                                  rounded
                                />
                                {/* <img src={`${e.image}&size=34`} className="rounded"/> */}
                                <span className="align-self-center ml-2">
                                  {e.label}
                                </span>
                              </div>
                            )}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3 col-md-4">
                          <Select
                            isMulti
                            value={dropdownExpend.DATA.filter(
                              (e) => e.selected === true
                            )}
                            menuPlacement="top"
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder={'ค่าใช้จ่ายอื่นๆ'}
                            options={dropdownExpend.DATA}
                            onChange={(v: any) => {
                              console.log(v);
                              setNewSelected(v);
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3 col-md-2">
                          <Form.Control
                            type="number"
                            placeholder="(บาท)"
                            disabled
                            onChange={() => {}}
                            value={plan.totalExpend}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3 col-md-6">
                          <SelectedBox
                            selected={dropdownExpend.DATA}
                            onValueChange={onValueChange}
                          />
                        </Form.Group>
                        <p
                          className="text-danger col-md-12 content"
                          dangerouslySetInnerHTML={{__html: error}}
                        ></p>
                        {/* <Form.Group className="mb-3 col-md-12">
                          {ibcApv ? (
                            <PfButton
                              className="col-md-4 col-12"
                              disabled={disable}
                              block
                              theme="success"
                              onClick={handleSubmit}
                              loading={isLoading}
                            >
                              ยืนยัน
                            </PfButton>
                          ) : (
                            <Button
                              className="ml-2"
                              variant="outline-danger"
                              disabled={true}
                            >
                              Costcenter : {plan.costid.label.split(':')[0]}{' '}
                              ถูกระงับชั่วคราว, กรุณาติดต่อ ibc คุณ
                              {plan.apvPlanIbcid.label}{' '}
                              เพื่อพิจารณาค่าใช้จ่ายรายเดือน{' '}
                              <a
                                href="https://youtu.be/-XlUNs4fqTY"
                                target="_blank"
                              >
                                รับชมวิดีโอสาธิต
                              </a>
                            </Button>
                          )}
                        </Form.Group> */}
                      </div>
                    </Tab>
                    <Tab eventKey="map" title="วางแผนที่">
                      <div
                        style={{
                          height: '55vh',
                          width: '100%',
                          paddingBottom: '5vh'
                        }}
                      >
                        {apiReady.current && (
                          <div className="row mb-2">
                            <SearchBox
                              mapApi={mapApi.current}
                              map={mapRef.current}
                              addplace={addPlace}
                            />
                            <Button
                              className="col-3 col-md-2 ml-2 mr-2"
                              variant="info"
                              onClick={ResetMap}
                            >
                              Reset
                            </Button>
                            <div className="m-0 p-0 col-md-3 col-6">
                              <BootstrapSwitchButton
                                style="w-100"
                                // width={100}
                                checked={modeRef.current}
                                onlabel="Partner On"
                                onstyle="success"
                                offlabel="Partner Off"
                                offstyle="danger"
                                onChange={(checked: boolean) => {
                                  modeRef.current = checked;
                                  console.log(checked);
                                  if (!checked) {
                                    setMarker([]);
                                    setCompany([]);
                                    companyRef.current = [];
                                    setCompanySelected([]);
                                  }
                                }}
                              />
                            </div>
                            {/* <Switch
                              bsSize={'normal'}
                              onText={'partner on'}
                              offText={'off'}
                              offColor={'success'}
                              onChange={(el, state: any) => {
                                setPartnerMode(state);
                              }}
                              value={isPartnerMode}
                            /> */}
                          </div>
                        )}
                        <GoogleMapReact
                          options={getMapOptions}
                          bootstrapURLKeys={{
                            // AIzaSyB88aLnfSb_Fe1_q8483R6_jcZjKznODWo
                            // key: 'AIzaSyCRKtowMDI_bkZpeIcut4jDnuhDXbaMBG0',
                            // key: 'AIzaSyB88aLnfSb_Fe1_q8483R6_jcZjKznODWo',
                            key: 'AIzaSyD2strutsAxeWXJwqDIE6Oq4EYGy5A6ji4',
                            libraries: ['places', 'geometry', 'marker']
                          }}
                          // defaultCenter={myposition.center}
                          zoom={myposition.zoom}
                          center={myposition.center}
                          defaultZoom={myposition.zoom}
                          yesIWantToUseGoogleMapApiInternals
                          onGoogleApiLoaded={({map, maps}) => {
                            console.log('THIS');
                            handleApiLoaded(map, maps);
                          }}
                        >
                          {showMarker &&
                            marker.map((place, id, array) => (
                              <Marker
                                addByMap={addByMap}
                                // setCompanySelected={setCompanySelected}
                                key={`${id}_${Math.random()
                                  .toString(16)
                                  .slice(-4)}`}
                                array={array}
                                position={place}
                                map={mapRef.current}
                              />
                            ))}
                        </GoogleMapReact>
                      </div>
                    </Tab>
                  </Tabs>
                </Card.Body>
              </Card>
            </div>
            <div className="col-12 col-md-3">
              <Card className="card-primary">
                <Card.Header>งบคงเหลือ (costcenter)</Card.Header>
                <Card.Body>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text" style={{width: 130}}>
                        {plan.costid.label.split(':')[0]}
                      </div>
                    </div>
                    <input
                      style={{
                        textAlign: 'right',
                        backgroundColor: plan.budget <= 0 ? '#ffd2da' : 'white'
                      }}
                      disabled
                      type="text"
                      className="form-control"
                      value={plan.budget}
                    />
                  </div>
                </Card.Body>
                <Card.Footer>
                  <div className="d-flex justify-content-between">
                    <div className="p-2">
                      {(plan.distance / 1000).toFixed(2)} Km.
                    </div>
                    <div className="p-2">
                      {plan.vehicleid.length === 1 &&
                      (plan.vehicleid[0].value === 'CS_22' ||
                        plan.vehicleid[0].value === 'CS_922')
                        ? 1800
                        : ((plan.distance / 1000) * 5.5).toFixed(2)}{' '}
                      บาท/วัน
                    </div>
                  </div>
                </Card.Footer>
              </Card>

              <Card className="card-primary">
                <Card.Header>คู่ค้า, บอกเราหน่อยคุณไปพบใคร</Card.Header>
                <Card.Footer>
                  <div className="input-group">
                    <Select
                      placeholder={'คู่ค้า, (Partner)'}
                      className="col-12"
                      isMulti={true}
                      value={companySelected}
                      // options={company.map((e, i) => ({
                      //   ...e,
                      //   label: `(${i + 1}). ${e.label}`
                      // }))}
                      options={company}
                      formatOptionLabel={(e) => (
                        <div className="d-flex">
                          <span className="info-box-icon">
                            <div className="numberCircle3">{e.index + 1}</div>
                          </span>
                          <span className="align-self-center ml-2">
                            {e.label}
                          </span>
                        </div>
                      )}
                      onChange={(v: any) => {
                        console.log(v);
                        setCompanySelected(v);
                        // companyRef.current = v;
                      }}
                    />
                  </div>
                </Card.Footer>
              </Card>

              <Card className="card-primary">
                <Card.Header>สถานที่ (ขยับเลื่อนได้)</Card.Header>
                <div
                  className="container"
                  style={{
                    height: '44vh',
                    width: '100%',
                    overflowY: 'scroll'
                  }}
                >
                  <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="droppable">
                      {(provided, snapshot) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={getListStyle(snapshot.isDraggingOver)}
                        >
                          {places.map((e, index) => (
                            <Column
                              // key={index}
                              index={index}
                              place={e}
                              draggableId={`${index}`}
                              onDelete={onDelete}
                            ></Column>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </Card>
            </div>
            <div className="bottom-freeze">
              <Form.Group
                className="mb-2 col-md-12 mt-2"
                style={{display: 'flex', justifyContent: 'flex-end'}}
              >
                {ibcApv ? (
                  <PfButton
                    className="col-md-2 col-12"
                    disabled={disable}
                    block
                    theme="success"
                    onClick={handleSubmit}
                    loading={isLoading}
                  >
                    ยืนยัน
                  </PfButton>
                ) : (
                  <Button
                    className="ml-2 col-md-9"
                    variant="outline-danger"
                    disabled={true}
                  >
                    Costcenter : {plan.costid.label.split(':')[0]}{' '}
                    ถูกระงับชั่วคราว, กรุณาติดต่อ ibc คุณ
                    {
                      plan.apvPlanIbcid.label
                    } เพื่อพิจารณาค่าใช้จ่ายรายเดือน{' '}
                    <a href="https://youtu.be/-XlUNs4fqTY" target="_blank">
                      รับชมวิดีโอสาธิต
                    </a>
                  </Button>
                )}
              </Form.Group>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
